import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "countdown flex flex-col items-center justify-center p-2 md:p-4 lg:p-6 rounded-lg shadow-lg" }
const _hoisted_2 = { class: "countdown-content flex flex-wrap justify-center items-center gap-2 md:gap-4 lg:gap-6" }
const _hoisted_3 = { class: "countdown-item bg-gray-200 p-2 rounded-lg shadow-md transition-transform transform hover:scale-105" }
const _hoisted_4 = { class: "countdown-number text-xl md:text-4xl font-extrabold text-gray-800" }
const _hoisted_5 = { class: "countdown-item bg-gray-200 p-2 rounded-lg shadow-md transition-transform transform hover:scale-105" }
const _hoisted_6 = { class: "countdown-number text-xl md:text-4xl font-extrabold text-gray-800" }
const _hoisted_7 = { class: "countdown-item bg-gray-200 p-2 rounded-lg shadow-md transition-transform transform hover:scale-105" }
const _hoisted_8 = { class: "countdown-number text-xl md:text-4xl font-extrabold text-gray-800" }
const _hoisted_9 = { class: "countdown-item bg-gray-200 p-2 rounded-lg shadow-md transition-transform transform hover:scale-105" }
const _hoisted_10 = { class: "countdown-number text-xl md:text-4xl font-extrabold text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.days), 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "countdown-label text-xs md:text-sm text-gray-600" }, "Hari", -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.hours), 1),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "countdown-label text-xs md:text-sm text-gray-600" }, "Jam", -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.minutes), 1),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "countdown-label text-xs md:text-sm text-gray-600" }, "Menit", -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.seconds), 1),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "countdown-label text-xs md:text-sm text-gray-600" }, "Detik", -1))
      ])
    ])
  ]))
}